import { useSelector } from 'react-redux'

import type { Props as ContentHeaderProps } from 'ui-component-library/components/ContentHeader'
import { getBreadcrumbs } from 'store/pages/selectors'
import ContentHeader from 'ui-component-library/components/ContentHeader'

function ContentHeaderContainer(props: ContentHeaderProps) {
  const breadcrumbs = useSelector(getBreadcrumbs)
  return <ContentHeader breadcrumbs={breadcrumbs} {...props} />
}

export default ContentHeaderContainer
